import { request } from '@/lib/api'
import type { ForecastStatus } from '@/card/dealApi'

/**
 * Отчёт о качестве модели прогноза сделок (#128) — `/sales/forecast/model`.
 *
 * Поля, которых нет у отказа обучиться («мало данных»), сервер не присылает вовсе
 * (`non_null`): метрик нет — значит их нет, а не нули.
 */
export const RESOURCE = 'sales.forecast'
export const MODEL_KEY = ['forecast-model'] as const

export interface Scores {
  /** Нет — в отложенной выборке один исход, AUC не определён (это не 0.5). */
  auc?: number | null
  logLoss: number
  brier: number
}

export interface CalibrationBucket {
  from: number
  to: number
  count: number
  /** Нет — в корзину никто не попал; это не «прогноз 0 и выиграно 0». */
  meanPredicted?: number | null
  actualRate?: number | null
}

export interface ModelMetrics {
  model: Scores
  baseline: Scores
  calibration: CalibrationBucket[]
  trainWinRate: number
  holdoutWinRate: number
}

export interface Coefficient {
  code: string
  weight: number
}

export interface ModelReport {
  status: ForecastStatus
  modelId?: string
  trainedAt?: string
  closedDeals?: number
  minClosedDeals?: number
  trainDeals?: number
  holdoutDeals?: number
  trainExamples?: number
  holdoutExamples?: number
  holdoutFrom?: string
  message?: string
  metrics?: ModelMetrics
  coefficients: Coefficient[]
  leadSources: string[]
  forecastDeals: number
  configuredMinClosedDeals: number
}

export function fetchModelReport(signal?: AbortSignal): Promise<ModelReport> {
  return request<ModelReport>('/sales/forecast/model', { signal })
}

export function trainModel(): Promise<ModelReport> {
  return request<ModelReport>('/sales/forecast/model/train', { method: 'POST', body: {} })
}
